import { render, staticRenderFns } from "./AccountSavedAddress.vue?vue&type=template&id=589747bf&scoped=true&lang=pug"
import script from "./AccountSavedAddress.vue?vue&type=script&lang=js"
export * from "./AccountSavedAddress.vue?vue&type=script&lang=js"
import style0 from "./AccountSavedAddress.vue?vue&type=style&index=0&id=589747bf&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589747bf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('589747bf')) {
      api.createRecord('589747bf', component.options)
    } else {
      api.reload('589747bf', component.options)
    }
    module.hot.accept("./AccountSavedAddress.vue?vue&type=template&id=589747bf&scoped=true&lang=pug", function () {
      api.rerender('589747bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/account/AccountSavedAddress.vue"
export default component.exports